import type { ReactNode } from 'react';

export function Card({
  title, subtitle, actions, children, as: Heading = 'h2',
}: {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  /** O nível do título é do CONTEXTO, não do componente: um card dentro de uma
   *  seção que já tem h2 precisa de h3, senão o índice de cabeçalhos do leitor
   *  de tela pula nível. */
  as?: 'h2' | 'h3' | 'h4';
}) {
  return (
    <section className="card">
      {(title || actions) && (
        <header className="card__header">
          <div>
            {title && <Heading className="card__title">{title}</Heading>}
            {subtitle && <p className="card__sub">{subtitle}</p>}
          </div>
          {actions}
        </header>
      )}
      {children}
    </section>
  );
}
